import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import axios from 'axios';

// Layout
import Header from '../layout/header';
import Footer from '../layout/footer';

// Elements
import AvailableCitiesModal from '../elements/available-cities-modal';
import Modal from '../elements/modal';
import { getLocalItem, getSessionItem } from '../../utils/storage';
import { startingPriceLabel } from '../../utils/pricing';

// Premium components
import {
  PremiumHero,
  SectionWrapper,
  FinalCTA,
  Breadcrumbs,
  StructuredData,
} from '../elements/premium';

class ContactUs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      phone: '',
      message: '',
      emailError: '',
      emptyMessageError: '',
      phoneError: '',
      submitting: false,
    };
  }

  componentDidMount() {
    const { setOpenModal, user } = this.props;
    if (
      getLocalItem('phone_provided') !== 'yes' &&
      getSessionItem('phone_ignored') !== 'yes' &&
      !user.is_logged
    ) {
      setOpenModal(true);
    }
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  validateEmail(email) {
    return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(email);
  }

  validatePhone(phone) {
    return /^(?:(?:\+|0{0,2})91(\s*[-]\s*)?|[0]?)?[6789]\d{9}$/.test(phone);
  }

  handleSendMessage = async (e) => {
    e.preventDefault();
    const { name, email, phone, message } = this.state;
    const { history } = this.props;

    let valid = true;
    this.setState({ emailError: '', phoneError: '', emptyMessageError: '' });

    if (!this.validateEmail(email)) {
      this.setState({ emailError: 'Please enter a valid email address' });
      valid = false;
    }
    if (!this.validatePhone(phone)) {
      this.setState({ phoneError: 'Please enter a valid phone number' });
      valid = false;
    }
    if (!message.trim()) {
      this.setState({ emptyMessageError: 'Please enter a message describing your query' });
      valid = false;
    }
    if (!valid) return;

    this.setState({ submitting: true });
    try {
      const response = await axios.post('https://ridenrepair.com/api/sendemail', { name, email, phone, message });
      if (response.status === 200) {
        history.push('/thank-you-email');
      }
    } catch (error) {
      // silently handle
    } finally {
      this.setState({ submitting: false });
    }
  };

  render() {
    const { isMobileBrowser, isMobileApp, user, setUser, citiesModal, setCitiesModal, openModal, setOpenModal } = this.props;
    const { name, email, phone, message, emailError, phoneError, emptyMessageError, submitting } = this.state;

    const schema = {
      '@type': 'ContactPage',
      name: 'Contact Ride N Repair',
      url: 'https://www.ridenrepair.com/contact',
      description: 'Get in touch with Ride N Repair for bike and car service inquiries.',
    };

    return (
      <div className="rr-home rr-home--lux">
        <Helmet>
          <link rel="canonical" href="https://www.ridenrepair.com/contact" />
          <title>Contact Us — Ride N Repair</title>
          <meta name="description" content="Get in touch with Ride N Repair for bike and car service inquiries. Call +91 120 361 5050 or email info@ridenrepair.com." />
          <meta property="og:title" content="Contact Ride N Repair" />
          <meta property="og:url" content="https://www.ridenrepair.com/contact" />
        </Helmet>

        <StructuredData data={schema} />

        {citiesModal && <AvailableCitiesModal closeModal={() => setCitiesModal(false)} />}
        {!isMobileApp && openModal && (
          <Modal isMobileBrowser={isMobileBrowser} isMobileApp={isMobileApp} openModal={openModal} setOpenModal={setOpenModal} user={user} setUser={setUser} />
        )}

        <Header isMobileBrowser={isMobileBrowser} isMobileApp={isMobileApp} user={user} setUser={setUser} />

        <PremiumHero
          compact
          badge="Get in Touch"
          title="Contact Ride N Repair"
          subtitle="Have questions? We're here to help — call, email, or send us a message"
          isMobileBrowser={isMobileBrowser}
          ctas={[
            { label: 'Call +91 120 361 5050', href: 'tel:+911203615050', variant: 'primary' },
            { label: 'Email Us', href: 'mailto:info@ridenrepair.com', variant: 'secondary' },
          ]}
        />

        <Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'Contact Us' }]} />

        {/* CONTACT INFO CARDS */}
        <SectionWrapper kicker="Reach Us" heading="Contact Information">
          <div className="rr-service-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))' }}>
            <div className="rr-service-card" style={{ cursor: 'default' }}>
              <span className="rr-service-card__icon">📞</span>
              <span className="rr-service-card__label">Phone</span>
              <a href="tel:+911203615050" className="rr-service-card__desc" style={{ color: '#f42222', textDecoration: 'none' }}>+91 120 361 5050</a>
            </div>
            <div className="rr-service-card" style={{ cursor: 'default' }}>
              <span className="rr-service-card__icon">✉️</span>
              <span className="rr-service-card__label">Email</span>
              <a href="mailto:info@ridenrepair.com" className="rr-service-card__desc" style={{ color: '#f42222', textDecoration: 'none' }}>info@ridenrepair.com</a>
            </div>
            <div className="rr-service-card" style={{ cursor: 'pointer' }} onClick={() => setCitiesModal(true)}>
              <span className="rr-service-card__icon">🏙️</span>
              <span className="rr-service-card__label">Cities We Serve</span>
              <span className="rr-service-card__desc">32+ cities across India</span>
            </div>
            <div className="rr-service-card" style={{ cursor: 'default' }}>
              <span className="rr-service-card__icon">🌐</span>
              <span className="rr-service-card__label">Follow Us</span>
              <span className="rr-service-card__desc" style={{ display: 'flex', gap: 16, justifyContent: 'center', alignItems: 'center' }}>
                <a href="https://www.facebook.com/weridenrepair" target="_blank" rel="noreferrer" aria-label="Facebook" style={{ fontSize: 24, color: '#1877F2' }}><i className="fa fa-facebook"></i></a>
                <a href="https://www.instagram.com/weridenrepair" target="_blank" rel="noreferrer" aria-label="Instagram" style={{ fontSize: 24, color: '#E4405F' }}><i className="fa fa-instagram"></i></a>
                <a href="https://www.linkedin.com/company/ride-n-repair/" target="_blank" rel="noreferrer" aria-label="LinkedIn" style={{ fontSize: 24, color: '#0A66C2' }}><i className="fa fa-linkedin"></i></a>
                <a href="https://www.youtube.com/channel/UC8RXTAzOW0SRX7whOyK-yJg" target="_blank" rel="noreferrer" aria-label="YouTube" style={{ fontSize: 24, color: '#FF0000' }}><i className="fa fa-youtube"></i></a>
              </span>
            </div>
          </div>
        </SectionWrapper>

        {/* CONTACT FORM */}
        <SectionWrapper variant="gray" kicker="Send a Message" heading="Have a Question? Write to Us">
          <form
            className="rr-contact-form"
            onSubmit={this.handleSendMessage}
            noValidate
          >
            <div className="rr-contact-form__row">
              <div className="rr-contact-form__field">
                <label htmlFor="contact-name">Your Name</label>
                <input
                  id="contact-name"
                  name="name"
                  type="text"
                  placeholder="Full Name"
                  value={name}
                  onChange={this.handleChange}
                  required
                />
              </div>
              <div className="rr-contact-form__field">
                <label htmlFor="contact-email">Email Address</label>
                <input
                  id="contact-email"
                  name="email"
                  type="email"
                  placeholder="you@example.com"
                  value={email}
                  onChange={this.handleChange}
                  required
                />
                {emailError && <p className="rr-contact-form__error">{emailError}</p>}
              </div>
              <div className="rr-contact-form__field">
                <label htmlFor="contact-phone">Phone Number</label>
                <input
                  id="contact-phone"
                  name="phone"
                  type="tel"
                  placeholder="+91 98765 43210"
                  value={phone}
                  onChange={this.handleChange}
                  required
                />
                {phoneError && <p className="rr-contact-form__error">{phoneError}</p>}
              </div>
            </div>
            <div className="rr-contact-form__field">
              <label htmlFor="contact-message">Your Message</label>
              <textarea
                id="contact-message"
                name="message"
                rows="5"
                placeholder="Describe your question or concern..."
                value={message}
                onChange={this.handleChange}
                required
              />
              {emptyMessageError && <p className="rr-contact-form__error">{emptyMessageError}</p>}
            </div>
            <div className="rr-text-center" style={{ marginTop: 24 }}>
              <button type="submit" className="rr-cta-primary" disabled={submitting}>
                {submitting ? 'Sending...' : 'Send Message'}
              </button>
            </div>
          </form>
        </SectionWrapper>

        {/* CTA */}
        <FinalCTA
          heading={<>Need Immediate Help?<br />Book a Service or Call Us Now.</>}
          subtitle={`Doorstep service · Certified mechanics · Starting ${startingPriceLabel('site')} · 30-day warranty`}
          ctas={[
            { label: 'Book Now', href: '/service', variant: 'primary' },
            { label: 'Call +91 120 361 5050', href: 'tel:+911203615050', variant: 'white-outline' },
          ]}
        />

        <Footer isMobileBrowser={isMobileBrowser} isMobileApp={isMobileApp} setCitiesModal={setCitiesModal} />
      </div>
    );
  }
}

export default ContactUs;
